function SpinnerLoading({mensagemLoading}) {

    return (
        <div className='p-1 align-items-center gap-3 d-flex justify-content-center'>
            <div className="spinner-border" role="status" > {/* style={{ 'color': '#004a80' }} CASO QUEIRA MUDAR A COR DO SPIN */}
                <span className="visually-hidden">Carregando ...</span>
            </div>
            <p className='m-0'>{mensagemLoading} ...</p>
        </div>
    )
}

export default SpinnerLoading